<template>
    <div class="btn-row">
        <div class="row mb-3 mar-0">
            <div class="col-12 p-0 svg-back" @click="close()">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                >
                    <path
                        d="m11.767 10 7.867-7.866A1.25 1.25 0 1 0 17.866.366L10 8.233 2.134.366A1.25 1.25 0 1 0 .366 2.134L8.233 10 .366 17.866a1.25 1.25 0 0 0 1.768 1.768L10 11.767l7.866 7.867a1.25 1.25 0 1 0 1.768-1.768L11.767 10z"
                        fill="#000"
                    />
                </svg>
            </div>
            <div class="col-12 p-0">
                <Button
                    class="btn-confirm"
                    :btnId="primaryBtnId"
                    :btnMsg="primaryBtnMsg"
                    @clickButton="clickPrimaryBtn"
                />
            </div>
        </div>
    </div>
</template>
<script>
import Button from "./Button.vue";
export default {
    name: "ValidateButton",
    components: {
        Button,
    },
    props: {
        primaryBtnId: String,
        primaryBtnMsg: String,

        secondaryBtnId: String,
        secondaryBtnMsg: String,
    },
    methods: {
        //event
        clickPrimaryBtn: function () {
            this.$emit("clickPrimaryBtn");
        },
        clickSecondaryBtn: function () {
            this.$emit("clickSecondaryBtn");
        },
        close: function () {
            this.$router.go();
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/style/base/baseDisplay.scss";
@import "@/style/_mixin.scss";
.btn-row {
    width: 100%;

    .svg-back {
        position: absolute;
        text-align: end;
        left: -15px;
        top: 10px;
    }
    .btn-confirm {
        text-align: center;
        border-radius: 4px;
        border: solid 1px $color-text;
        background-color: $color-text;
        padding: 5px;
        color: #fff;
        font-family: "PromptSemiBold";
        font-size: 16px;
        border-radius: 25px;
        width: 100%;
    }
    .btn-cancel {
    }
    .btn-primary {
        display: inline-block;
        width: calc(50% - 7.5px);
        margin-left: 7.5px;
    }

    .btn-secondary {
        display: inline-block;
        width: calc(50% - 7.5px);
        margin-right: 7.5px;
    }
}
</style>
